import { BulkDeleteButton, Create, Edit, List, SimpleForm, BooleanInput, ReferenceArrayInput, TextInput, required, AutocompleteArrayInput, Datagrid, TextField, EditButton } from 'react-admin';
import { default as icon } from '@mui/icons-material/Groups';

const list = () =>
    <List>
		<Datagrid bulkActionButtons={<BulkDeleteButton mutationMode="pessimistic" />}>
			<TextField source="name" />
			<EditButton />
		</Datagrid>
    </List>;

const FormFields = (
		<SimpleForm warnWhenUnsavedChanges>
			<TextInput source="name" validate={required()} />
			<ReferenceArrayInput reference="users" source="user_ids">
				<AutocompleteArrayInput source="name" label="Users" />
			</ReferenceArrayInput>
			<ReferenceArrayInput reference="sessions" source="session_ids">
				<AutocompleteArrayInput source="name" label="Sessions" />
			</ReferenceArrayInput>
			<BooleanInput source="active" defaultValue={true} />
		</SimpleForm>
);

const edit = () => <Edit redirect="edit">{FormFields}</Edit>;
const create = () => <Create>{FormFields}</Create>;

export const Group = { list, edit, create, icon };

export default Group;